// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9267) return "static/chunks/9267-abc07a435dbbbab3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"542":"f4b14bb8f0ac8e97","4029":"a7d9bd1e1e91c64c"}[chunkId] + ".js";
};